import classes from './Waves.module.scss';
import Wave from '../assets/lightwave.png';
const Lightwave = () => {
  return <img src={Wave} alt='' className={classes.Lightwave} />;
};

export default Lightwave;
